import environment from "../../../environment/environment";
import routes from "../common/api-routes";
import {HttpGet, HttpPost, HttpDownloadFile} from "../common/HttpRequestBuilder";

const SUBSCRIPTION_KEY = environment.service_baseUrl.subscriptionKey;

const listReportLogs = (startDate, endDate, report_type) => {

    let payload = {
        start_date: startDate,
        end_date : endDate, 
        report_type: report_type,
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.LIST_REPORT_LOGS, payload, subscriptionKey);
    return result;
}

const listReportLogsByGeneratedBy = (startDate, endDate, report_type, generated_by) => {

    let payload = {
        start_date: startDate,
        end_date : endDate, 
        report_type: report_type,
        generated_by: generated_by
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.LIST_REPORT_LOGS, payload, subscriptionKey);
    return result;
}

const listReportLogsByStatus = (startDate, endDate, report_type, status) => {

    let payload = {
        start_date: startDate,
        end_date : endDate, 
        report_type: report_type,
        status: status
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.LIST_REPORT_LOGS, payload, subscriptionKey);
    return result;
}

const listReportLogsByGeneratedByAndStatus = (startDate, endDate, report_type, generated_by, status) => {

    let payload = {
        start_date: startDate,
        end_date : endDate, 
        report_type: report_type,
        generated_by: generated_by,
        status: status
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.LIST_REPORT_LOGS, payload, subscriptionKey);
    return result;
}

const viewReportLogs = (reportId) => {

    let query_params = {
        report_id: reportId
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.VIEW_REPORT_LOGS, query_params, subscriptionKey);
    return result;
}


const downloadReportLogs = (reportId) => {

    let query_params = {
        report_id: reportId
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpDownloadFile(routes.DOWNLOAD_REPORT_LOGS, query_params, subscriptionKey);
    return result;
}


const ReportLogsService = {
    listReportLogs,
    listReportLogsByGeneratedBy,
    listReportLogsByStatus,
    viewReportLogs,
    listReportLogsByGeneratedByAndStatus,
    downloadReportLogs,
}

export default ReportLogsService
